import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useUserStore } from '../store/userStore'

type Props = { requiredRole?: string; element: React.ReactElement }

export const AuthenticatedRoute = ({ element, requiredRole }: Props) => {
    const user = useUserStore(state => state.user)
    const location = useLocation()

    if (!user.authenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (requiredRole && !user.Role.includes(requiredRole)) {
        return <Navigate to="/" replace />
    }

    return element
}
